import { cn } from '@/shared/lib';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  /** Announced to screen readers while the spinner is visible. */
  label?: string;
  className?: string;
};

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
} as const;

/** Indeterminate loading indicator. */
export const Spinner = ({ size = 'md', label = 'Loading', className }: SpinnerProps) => (
  <span role="status" aria-label={label} className="inline-flex">
    <span
      aria-hidden="true"
      className={cn(
        'animate-spin rounded-full border-current border-t-transparent text-primary',
        SIZES[size],
        className,
      )}
    />
  </span>
);
